import { render, staticRenderFns } from "./StudentFill.vue?vue&type=template&id=64022950&scoped=true&"
import script from "./StudentFill.vue?vue&type=script&lang=js&"
export * from "./StudentFill.vue?vue&type=script&lang=js&"
import style0 from "./StudentFill.vue?vue&type=style&index=0&id=64022950&lang=scss&scoped=true&"
import style1 from "./StudentFill.vue?vue&type=style&index=1&id=64022950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64022950",
  null
  
)

/* custom blocks */
import block0 from "./StudentFill.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports